import type { ReactNode } from 'react'

interface ParallaxLayerProps {
  children?: ReactNode
  speed?: number
  rotate?: number
  className?: string
}

export function ParallaxLayer({
  children,
  speed = 0.12,
  rotate = 0,
  className = '',
}: ParallaxLayerProps) {
  return (
    <div
      className={`parallax ${className}`.trim()}
      style={{ '--parallax-speed': speed, '--parallax-rotate': `${rotate}deg` }}
      aria-hidden="true"
    >
      {children}
    </div>
  )
}
